import { AffiltiationGraph } from '../CustomFilterComponents/AffiliationGraph';
import { CareTeam } from '../CustomFilterComponents/CareTeam';
import ChannelRecency from '../CustomFilterComponents/ChannelRecency';
import ClinicalFilters from '../CustomFilterComponents/ClinicalFilters';
import ClinicalRecency from '../CustomFilterComponents/ClinicalRecency';
import DomainsSlider from '../CustomFilterComponents/DomainsSlider';
import Email from '../CustomFilterComponents/EmailFilter';
import { IncludeExcludeFilter } from '../CustomFilterComponents/IncludeExcludeFilter';
import Media from '../CustomFilterComponents/MediaFilter';
import { NpiListName } from '../CustomFilterComponents/NpiListName';
import PrescribingBehaviorFilter from '../CustomFilterComponents/PrescribingBehaviorFilter';
import ProfessionAndSpeciality from '../CustomFilterComponents/ProfessionAndSpeciality';
import RangeDualSlider from '../CustomFilterComponents/RangeDualSlider';
import Search from '../CustomFilterComponents/SearchFilter';
import Site from '../CustomFilterComponents/SiteFilter';
import Social from '../CustomFilterComponents/SocialFilter';
import TagCollection from '../CustomFilterComponents/TagCollection';
import ToggleFilterWithRecency from '../CustomFilterComponents/ToggleFilterWithRecency';
import { TreeIncludeExcludeFilter } from '../CustomFilterComponents/TreeIncludeExcludeFilter';
import { MatchTypeFilter } from '../MatchTypeFilters';
import { renderCategoryWithHashHighlight } from './utils/renderCategoryWithHashHighlight';

export const IABTreeFilter = (
  <TreeIncludeExcludeFilter
    dictionary="IAB"
    filterName="contextual_iab_taxonomy_id_filter"
    decileFilterName="contextual_iab_decile_filter"
    recencyFilterName="contextual_lookback_period_filter"
  />
);

export const MeshTreeFilter = (
  <TreeIncludeExcludeFilter
    dictionary="MeSH"
    filterName="contextual_mesh_taxonomy_id_filter"
    decileFilterName="contextual_mesh_decile_filter"
    recencyFilterName="contextual_lookback_period_filter"
  />
);

export const PatientAgeRangeComponent = (
  <ToggleFilterWithRecency
    filterName={'patient_age_range_filter'}
    recencyName={'claims_lookback_period_filter'}
    recencyLabel="Clinical"
  />
);

export const InsuranceProviderComponent = (
  <ClinicalFilters
    label="Insurance"
    includeExcludeFilterName="patient_insurance_provider_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const PatientStateComponent = (
  <ClinicalFilters
    label="States"
    includeExcludeFilterName="patient_state_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const PatientFacilityComponent = (
  <ClinicalFilters
    label="Facility"
    includeExcludeFilterName="patient_facility_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const AgeRangeComponent = <ToggleFilterWithRecency filterName="age_range_filter" />;

export const YearsPracticedRangeComponent = <ToggleFilterWithRecency filterName="years_practiced_range_filter" />;

export const NetWorthComponent = <ToggleFilterWithRecency filterName="net_worth_filter" />;

export const StateNameComponent = <IncludeExcludeFilter label="State" filterName="state_name_filter" />;

export const MedicalSchoolComponent = <IncludeExcludeFilter label="School" filterName="medical_school_filter" />;

export const GraduationYearComponent = <RangeDualSlider filterName="graduation_year_filter" />;

export const PatientGenderComponent = (
  <ToggleFilterWithRecency
    filterName={'patient_gender_filter'}
    recencyName={'claims_lookback_period_filter'}
    recencyLabel="Clinical"
  />
);
export const InsuranceTypeComponent = (
  <ToggleFilterWithRecency
    filterName={'patient_insurance_type_filter'}
    recencyName={'claims_lookback_period_filter'}
    recencyLabel="Clinical"
  />
);

export const NumberOfPatientsComponent = (
  <ToggleFilterWithRecency
    filterName={'number_of_patients_range_filter'}
    recencyName={'claims_lookback_period_filter'}
    recencyLabel="Clinical"
  />
);

export const ProcedureNameComponent = (
  <ClinicalFilters
    label="Procedures"
    decilesFilterName="procedure_decile_filter"
    includeExcludeFilterName="procedure_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const ProcedureDecileComponent = (
  <ClinicalFilters
    label="Procedures"
    decilesFilterName="procedure_decile_filter"
    includeExcludeFilterName="procedure_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const DiagnosisNameComponent = (
  <ClinicalFilters
    label="Diagnosis"
    decilesFilterName="diagnosis_decile_filter"
    includeExcludeFilterName="diagnosis_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const DiagnosisDecileComponent = (
  <ClinicalFilters
    label="Diagnosis"
    decilesFilterName="diagnosis_decile_filter"
    includeExcludeFilterName="diagnosis_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const PrescribedDrugNameComponent = (
  <ClinicalFilters
    label="Drugs"
    decilesFilterName="prescribed_drug_decile_filter"
    includeExcludeFilterName="prescribed_drug_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const PrescribedDrugDecileComponent = (
  <ClinicalFilters
    label="Drugs"
    decilesFilterName="prescribed_drug_decile_filter"
    includeExcludeFilterName="prescribed_drug_name_filter"
    recencyFilterName="claims_lookback_period_filter"
    recencyLabel="Clinical"
  />
);

export const PrescribingBehaviorChangeComponent = <PrescribingBehaviorFilter />;

export const FacilityAffiliationComponent = <AffiltiationGraph />;

export const CareTeamComponent = <CareTeam />;

export const ContextualLookbackPeriodComponent = (
  <ClinicalRecency filterName="contextual_lookback_period_filter" label="Contextual" />
);
export const ClaimsLookbackPeriodComponent = (
  <ClinicalRecency filterName="claims_lookback_period_filter" label="Claims" />
);

export const GenderComponent = <ToggleFilterWithRecency filterName="gender_filter" />;

export const IABTaxonomyComponent = IABTreeFilter;

export const MeshTaxonomyComponent = MeshTreeFilter;

export const TopicDescriptorComponent = (
  <ClinicalFilters
    label="Categories"
    includeExcludeFilterName="contextual_topic_descriptor_filter"
    recencyFilterName="contextual_lookback_period_filter"
    recencyLabel="Contextual"
  />
);

export const ConceptDescriptorComponent = (
  <ClinicalFilters
    label="Categories"
    includeExcludeFilterName="contextual_concept_descriptor_filter"
    recencyFilterName="contextual_lookback_period_filter"
    recencyLabel="Contextual"
  />
);

export const NPIListNameComponent = <NpiListName />;

export const NPIMarketAreaComponent = (
  <IncludeExcludeFilter
    label="Market Area"
    filterName="npi_dma_filter"
    renderCategory={renderCategoryWithHashHighlight}
  />
);

export const FacilityNameComponent = <IncludeExcludeFilter label="Facility Name" filterName="facility_name_filter" />;

export const NPIZipcodeComponent = <IncludeExcludeFilter label="ZIP Code" filterName="npi_zipcode_filter" />;

export const ProfessionComponent = (
  <ProfessionAndSpeciality professionFilterName="profession_filter" specialtyFilterName="specialty_filter" />
);

export const EmailComponent = <Email />;

export const MediaComponent = <Media />;

export const SearchComponent = <Search />;

export const SiteComponent = <Site />;

export const SocialComponent = <Social />;

export const DomainsSliderComponent = <DomainsSlider />;

export const ChannelRecencyComponent = <ChannelRecency />;

export const TagCollectionComponent = <TagCollection />;

export const MatchTypeComponent = <MatchTypeFilter />;

export default MeshTreeFilter;
